import { DOCUMENT } from '@angular/common';
import { bootstrapApplication } from '@angular/platform-browser';
import {
  fieldViewPopoutComponentMap,
  PopoutWindowKey
} from '@app/core/shared/components/field-view/utilities/popout.window.utlity';
import { SHARED_PROVIDERS } from './shared-providers';

const popoutComponentMap = {
  ...fieldViewPopoutComponentMap
};

export function isPopoutWindow(): boolean {
  return !!popoutComponentMap[window.name as PopoutWindowKey];
}

function getPopoutComponentAndSelector() {
  const entry = popoutComponentMap[window.name as PopoutWindowKey];
  if (!entry) {
    throw new Error(`Unknown popout window name: ${window.name}`);
  }
  return entry;
}

function ensureRootElement(selector: string) {
  let el = document.querySelector(selector);
  if (el) {
    return;
  }
  const oldRoot = document.querySelector('app-root');
  if (oldRoot) {
    oldRoot.remove();
  }
  el = document.createElement(selector);
  document.body.appendChild(el);
}

/**
 * Bootstraps the popout window application
 * Must contain the same provers as main.ts
 * Returns a promise that resolves when bootstrapping is complete
 */
export function bootstrapPopoutWindow(): Promise<void> {
  const { component, selector } = getPopoutComponentAndSelector();
  ensureRootElement(selector);
  return bootstrapApplication(component, {
    providers: [
      { provide: 'POPUP_WINDOW', useValue: window },
      { provide: DOCUMENT, useFactory: () => window.document },
      // same shared providers as main.ts
      ...SHARED_PROVIDERS
    ]
  }).then(() => undefined);
}
